export default __webpack_public_path__ + "static/media/intro1.3d91ecff.mp3";